export class Time {

  /**
   * Sleep asynchronously for the given time
   * @param delay In MS
   */
  public static sleep(delay: number) {
    return new Promise((resolve) => setTimeout(resolve, delay));
  }
}

